import React, { Component } from "react";
import "./Modal.less";

class Modal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isOpen, title, children, onClose, size = "medium" } = this.props;

    if (!isOpen) return null;

    const sizeClass = {
      small: "consorcio-modal-small",
      medium: "consorcio-modal-medium",
      large: "consorcio-modal-large",
    }[size];

    return (
      <div className="consorcio-modal-overlay open">
        <div className={`consorcio-modal-content ${sizeClass}`}>
          <div className="consorcio-modal-header">
            <h2>{title}</h2>
            <span
              className="close-button"
              onClick={(e) => {
                e.preventDefault();
                onClose();
              }}
            >
              ✕
            </span>
          </div>
          <div className="header-divider"></div>
          <div className="consorcio-modal-body">{children}</div>
        </div>
      </div>
    );
  }
}

export default Modal;
